import { render, staticRenderFns } from "./magicCubeSetting.vue?vue&type=template&id=f7a2f54a&scoped=true&"
import script from "./magicCubeSetting.vue?vue&type=script&lang=js&"
export * from "./magicCubeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a2f54a",
  null
  
)

export default component.exports